import { render, staticRenderFns } from "./EditMapModal.vue?vue&type=template&id=5f1841e0"
import script from "./EditMapModal.vue?vue&type=script&lang=ts"
export * from "./EditMapModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports